import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/multiLocation/multiLocation";

export default connect(
  state => ({
    filterType: "FilterLevelLast",
    options: state.multiLocation.availableFilters.level_4,
    placeholder: "Please Select",
    selectAll: true,
    initFiltersLoaded: state.multiLocation.initFiltersLoaded,
    enableOnly: true,
    numberDisplayed: 0,
    includeSelectAll: true,
    defaultSelected: false,
    haveOnSelectChange: false
  }),
  {
    updateFilterLevel: data => actionCreators.updateSelectedFourthLevelFilters(data)
  }
)(MultiSelectDropdown);
